import React from 'react';
import CommerceDocsAdminPage from './CommerceDocsAdminPage';

export default function AdminInvoicesPage() {
  return <CommerceDocsAdminPage mode="invoice" />;
}
